import Media from 'imatic/vsem-design/assets/util/Media';
import Cookies from "js-cookie";

const LAYOUT_CYCLE = {
    "compact": "normal",
    "normal": "expanded",
    "expanded": "compact"
};

class CommunicatorSidebar {
    constructor(open = false) {
        const self = this;
        $(function () {
            self.$toggle = $('.vsem-header-toggle-button');
            self.$sidebar = $('.comm-sidebar');

            self.$toggle.click(() => {
                self.open = !self.open;
            });

            self.open = open;

            self.layout = Cookies.get('sidebarLayout') || 'normal';
        })
    }

    set open(state) {
        if (this._open === state) {
            return;
        }

        this.$toggle.toggleClass('open', state);
        this.$sidebar.toggleClass('sidebar-open', state);
        this._open = state;
    }

    get open() {
        return this._open;
    }

    set layout(layout) {
        if (layout === this._layout) {
            return;
        }

        this.$sidebar.removeClass(this._layout);

        this._layout = layout;

        this.$sidebar.addClass(this._layout);

    }

    get layout() {
        return this._layout;
    }

    cycleLayout() {
        this.layout = LAYOUT_CYCLE[this.layout] || 'normal';

        Cookies.set("sidebarLayout", this.layout);
    }
}

window.CommunicatorSidebar = new CommunicatorSidebar();
